export default "__VITE_ASSET__Bs_TbI40__"